import React from 'react';
import ModifierOptionsField from './ModifierOptionsField';

class ModifierOptionsFieldArray extends React.Component {
  render() {
    const { fields } = this.props;
    return (
      <div className="row">
        <div className="form-group col-sm-12 mb-0px">
          <button
            className="btn btn-primary btn-block"
            onClick={this.onClickAdd}
          >
            Add Options
          </button>
        </div>
        {fields.map((member, index) => (
          <ModifierOptionsField
            member={member}
            key={index}
            onDelete={() => this.onDelete(index)}
          />
        ))}
      </div>
    );
  }

  onDelete = index => {
    const { fields } = this.props;
    fields.remove(index);
  };

  onClickAdd = () => {
    const { fields } = this.props;
    fields.push({
      name: null,
      price: null,
    });
  };
}

export default ModifierOptionsFieldArray;
